import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SearchDivisionList } from "../../../model/divisions/DivisionsModel";

interface DivisionsInterface {
  divisionSelected?: SearchDivisionList | null;
}

const initialState: DivisionsInterface = {
  divisionSelected: null,
};

const divisionsSlice = createSlice({
  name: "divisions",
  initialState,
  reducers: {
    setDivisionDetail: (
      state,
      action: PayloadAction<SearchDivisionList | null>
    ) => {
      state.divisionSelected = action.payload;
    },
  },
});

export const { setDivisionDetail } = divisionsSlice.actions;
export default divisionsSlice.reducer;
